'use client';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import { forwardRef } from 'react';
import { Box } from '@wanteddev/wds-engine';
import WithInteraction from '../with-interaction/index.mjs';
import { scrollAreaStyle, viewportStyle, scrollBarStyle, scrollBarThumbStyle } from './style.mjs';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

var ScrollArea = forwardRef(
  ({
    children,
    asChild,
    viewportRef,
    scrollbars = "both",
    type = "hover",
    viewPortProps = {},
    zIndex,
    ...props
  }, ref) => {
    const scrollbarComponent = {
      both: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Box, { as: ScrollBar, orientation: "horizontal", sx: { zIndex } }),
        /* @__PURE__ */ jsx(Box, { as: ScrollBar, orientation: "vertical", sx: { zIndex } })
      ] }),
      vertical: /* @__PURE__ */ jsx(Box, { as: ScrollBar, orientation: "vertical", sx: { zIndex } }),
      horizontal: /* @__PURE__ */ jsx(Box, { as: ScrollBar, orientation: "horizontal", sx: { zIndex } })
    };
    return /* @__PURE__ */ jsxs(
      Box,
      {
        as: ScrollAreaPrimitive.Root,
        ref,
        type,
        ...props,
        sx: [scrollAreaStyle, props.sx],
        children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              as: ScrollAreaPrimitive.Viewport,
              asChild,
              ref: viewportRef,
              ...viewPortProps,
              sx: [viewportStyle, viewPortProps.sx],
              children
            }
          ),
          scrollbarComponent[scrollbars],
          /* @__PURE__ */ jsx(ScrollAreaPrimitive.Corner, {})
        ]
      }
    );
  }
);
ScrollArea.displayName = "ScrollArea";
var scroll_area_default = ScrollArea;
var ScrollBar = forwardRef(({ orientation = "vertical", ...props }, ref) => /* @__PURE__ */ jsx(
  Box,
  {
    as: ScrollAreaPrimitive.ScrollAreaScrollbar,
    forceMount: true,
    ref,
    orientation,
    ...props,
    sx: [scrollBarStyle({ orientation }), props.sx],
    children: /* @__PURE__ */ jsx(WithInteraction, { color: "palette.label.normal", children: /* @__PURE__ */ jsx(Box, { as: ScrollAreaPrimitive.ScrollAreaThumb, sx: scrollBarThumbStyle }) })
  }
));
ScrollBar.displayName = "ScrollBar";

export { scroll_area_default as default };
